import React, { useState, useRef } from "react";
import { Menu, MenuItem } from "@material-ui/core";
import ShareIcon from "@material-ui/icons/Share";
import ReplyIcon from "@material-ui/icons/Reply";
import CheckIcon from "@material-ui/icons/Check";
import { makeStyles } from "@material-ui/core/styles";
import Swal from "sweetalert2";

const useStyles = makeStyles(() => ({
  menuPaper: {
    border: "1px solid #dce3e9",
    borderRadius: "10px",
    boxShadow: "0 8px 24px rgba(30, 61, 102, 0.18)",
    minWidth: "210px"
  },
  menuList: {
    padding: "6px"
  },
  menuItem: {
    borderRadius: "7px",
    color: "#1e3d66",
    direction: "rtl",
    display: "flex",
    fontSize: "15px",
    fontWeight: 700,
    justifyContent: "space-between",
    minHeight: "44px",
    padding: "8px 12px",
    transition: "background-color 160ms ease, color 160ms ease",
    "&:hover": {
      backgroundColor: "#fff3dc",
      color: "#f39a08"
    }
  },
  menuIcon: {
    color: "#1e3d66",
    fontSize: "23px"
  },
  checkIcon: {
    color: "#58a83b",
    fontSize: "21px"
  },
  menuHeader: {
    borderBottom: "1px solid #dce3e9",
    color: "#1e3d66",
    direction: "rtl",
    fontSize: "14px",
    fontWeight: 700,
    marginBottom: "4px",
    minHeight: "38px"
  },
  emptyMenuItem: {
    color: "#7d8996",
    direction: "rtl",
    fontSize: "14px",
    justifyContent: "center",
    minHeight: "44px"
  }
}));

export default function MoveDealMenus(props) {
  const classes = useStyles();
  const {
    officeLawyers,
    dealSharingOptionsEvent,
    setDealSharingOptionsEvent,
    shareDeal,
    cancelShareDeal,
    transferDeal,
    dealIdBeingSharedOrTransferred,
    dealsPrettyIdAndDesc
  } = props;

  const [activeMenuType, setActiveMenuType] = useState(null);

  const nestedMenuType = useRef();

  const handleCloseDealSharingOptions = () => {
    setActiveMenuType(null);
    setDealSharingOptionsEvent(null);
  };

  const handleOpenLawyersMenu = (newNestedMenuType) => {
    nestedMenuType.current = newNestedMenuType;
    setActiveMenuType(newNestedMenuType);
  };

  const handleCloseLawyersMenu = () => {
    setActiveMenuType(null);
  };

  const handleChangeLawyerOwnershipOrShareDeal = (newOwnerEmail, dealNewLawyerName, isDealSharedWithLawyer) => {
    if (nestedMenuType.current === "transferMenu") {
      Swal.fire({
        title: "העברת עסקה",
        text: `להעביר עסקה לעורך הדין - ${dealNewLawyerName}?`,
        confirmButtonText: "כן",
        cancelButtonText: "לא",
        icon: "info",
        showCancelButton: true
      }).then((swalResult) => {
        if (swalResult.value) {
          transferDeal(newOwnerEmail, dealIdBeingSharedOrTransferred.dealId, dealNewLawyerName).then(() => {
            handleCloseLawyersMenu();
            handleCloseDealSharingOptions();
          });
        }
      });
    } else {
      // sharingMenu
      if (isDealSharedWithLawyer) {
        // Shared already.. stop sharing?
        Swal.fire({
          title: "הפסקת שיתוף עסקה",
          text: `להפסיק את שיתוף העסקה עם עורך הדין - ${dealNewLawyerName}?`,
          confirmButtonText: "כן",
          cancelButtonText: "לא",
          icon: "info",
          showCancelButton: true
        }).then((swalResult) => {
          if (swalResult.value) {
            cancelShareDeal(newOwnerEmail, dealIdBeingSharedOrTransferred.dealId);
          }
        });
      } else {
        Swal.fire({
          title: "שיתוף עסקה",
          text: `לשתף עסקה עם עורך הדין - ${dealNewLawyerName}?`,
          confirmButtonText: "כן",
          cancelButtonText: "לא",
          icon: "info",
          showCancelButton: true
        }).then((swalResult) => {
          if (swalResult.value) {
            shareDeal(newOwnerEmail, dealIdBeingSharedOrTransferred.dealId);
          }
        });
      }
    }
  };

  const isDealSharingOptionsOpen = Boolean(dealSharingOptionsEvent);

  const getLawyerList = () => {
    if (!dealIdBeingSharedOrTransferred || !officeLawyers) return [];

    const currentDeal = dealsPrettyIdAndDesc.find(
      (deal) => deal._id === dealIdBeingSharedOrTransferred.dealId
    );

    return officeLawyers.map((officeLawyer) => ({
      ...officeLawyer,
      isCurrentDealOwner: officeLawyer.email === dealIdBeingSharedOrTransferred.belongToEmail,
      isDealSharedWithLawyer:
        nestedMenuType.current === "sharingMenu" &&
        Boolean(currentDeal?.listOfSharedLawyers?.includes(officeLawyer.email))
    }));
  };

  const lawyerList = getLawyerList();

  return (
    <>
      <Menu
        id="sharing-menu"
        anchorEl={dealSharingOptionsEvent}
        open={isDealSharingOptionsOpen}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={handleCloseDealSharingOptions}
        classes={{ paper: classes.menuPaper, list: classes.menuList }}
        MenuListProps={{
          "aria-labelledby": "sharing-button"
        }}
      >
        {activeMenuType ? (
          <MenuItem className={classes.menuHeader} onClick={handleCloseLawyersMenu}>
            חזרה לבחירת פעולה ←
          </MenuItem>
        ) : null}
        {!activeMenuType ? (
          <MenuItem className={classes.menuItem} onClick={() => handleOpenLawyersMenu("sharingMenu")}>
            <span>שיתוף עסקה</span>
            <ShareIcon className={classes.menuIcon} />
          </MenuItem>
        ) : null}
        {!activeMenuType ? (
          <MenuItem className={classes.menuItem} onClick={() => handleOpenLawyersMenu("transferMenu")}>
            <span>העברת עסקה</span>
            <ReplyIcon className={classes.menuIcon} />
          </MenuItem>
        ) : null}
        {activeMenuType && lawyerList.length === 0 ? (
          <MenuItem className={classes.emptyMenuItem} disabled>
            לא נמצאו עורכי דין
          </MenuItem>
        ) : null}
        {activeMenuType
          ? lawyerList.map((officeLawyer) => (
              <MenuItem
                className={classes.menuItem}
                disabled={officeLawyer.isCurrentDealOwner}
                key={officeLawyer._id}
                onClick={() =>
                  handleChangeLawyerOwnershipOrShareDeal(
                    officeLawyer.email,
                    `${officeLawyer.firstName} ${officeLawyer.lastName}`,
                    officeLawyer.isDealSharedWithLawyer
                  )
                }
              >
                <span>
                  {`${officeLawyer.firstName} ${officeLawyer.lastName}`}
                  {officeLawyer.isCurrentDealOwner ? " (בעל העסקה)" : ""}
                </span>
                {officeLawyer.isDealSharedWithLawyer ? <CheckIcon className={classes.checkIcon} /> : null}
              </MenuItem>
            ))
          : null}
      </Menu>
    </>
  );
}
